// Mock data for SSF - Suministros y Servicios para Filtración

export const companyInfo = {
  name: "SSF",
  fullName: "SUMINISTROS Y SERVICIOS PARA FILTRACIÓN",
  logo: "/logo-ssf.png",
  slogan: "Soluciones profesionales en filtración y tratamientos de agua.",
  description: "Expertos en suministros, servicios de filtración y tratamientos de aguas para el sector Petrolero, Marítimo, Industrial, Hotelero y residencial, con más de 15 años de experiencia en el mercado."
};

export const navLinks = [
  { id: "somos", label: "Somos" },
  { id: "servicios", label: "Servicios" },
  { id: "clientes", label: "Clientes" },
  { id: "Marcas", label: "Marcas" },
  { id: "ubicacion", label: "Ubicación" }
];

export const aboutSection = {
  title: "¿Quiénes Somos?",
  description: "SSF es una empresa líder en suministros y servicios de filtración y tratamientos de aguas, comprometida con la excelencia y la innovación. Ofrecemos soluciones integrales adaptadas a las necesidades especificas de cada cliente.",
  values: [
    {
      title: "Experiencia",
      description: "Más de 15 años en el sector de filtración",
      icon: "award"
    },
    {
      title: "Calidad",
      description: "Productos certificados y de las mejores marcas",
      icon: "shield-check"
    },
    {
      title: "Servicio",
      description: "Atención personalizada y soporte técnico 24/7",
      icon: "headphones"
    },
    {
      title: "Innovación",
      description: "Tecnología de punta en sistemas de filtración",
      icon: "lightbulb"
    }
  ]
};

export const services = [
  {
    id: 1,
    title: "Fabricación de Equipo",
    description: "Diseño y fabricación de sistemas especializados para tratamiento de agua.",
    icon: "factory",
    features: ["Para renta", "Para venta"]
  },
  {
    id: 2,
    title: "Diagnostico y Reingenieria",
    description: "Procesos esenciales para asegurar la eficiencia y el cumplimiento normativo.",
    icon: "home",
    features: ["Integral", "Tecnologías avanzadas"]
  },
  {
    id: 3,
    title: "Mantenimiento Preventivo",
    description: "Programas de mantenimiento para asegurar el óptimo funcionamiento de sus sistemas de filtración.",
    icon: "wrench",
    features: ["Inspecciones periódicas", "Cambio de filtros", "Optimización de sistemas"]
  },
  {
    id: 4,
    title: "Servicios de Operación 24/7",
    description: "Consultoría especializada para seleccionar el sistema de filtración ideal según sus necesidades.",
    icon: "clipboard-list",
    features: ["Análisis de agua", "Diseño de sistemas", "Capacitación técnica"]
  },
  {
    id: 5,
    title: "Repuestos y Consumibles",
    description: "Amplio inventario de repuestos originales y consumibles para todo tipo de sistemas de filtración.",
    icon: "package",
    features: ["Filtros de repuesto", "Membranas", "Accesorios"]
  },
  {
    id: 6,
    title: "Rehabilitacion",
    description: "Servicio profesional de instalación de sistemas de filtración con garantía de calidad.",
    icon: "settings",
    features: ["Instalación certificada", "Pruebas de funcionamiento", "Garantía extendida"]
  }
];

export const clients = [
  {
    id: 1,
    name: "Grupo México",
    logo: "https://habitatmx.com/wp-content/uploads/2019/07/2D43EB7C-0670-49AE-828E-EB0B262B69ED.png",
    testimonial: "Se especializa en todas las ramas de mantenimientos y servicios necesarios para la filtración."
  },
  {
    id: 2,
    name: "PMI | Comercio Internacional",
    logo: "https://www.pmi.com.mx/SliderImages/Experiencia_940x240.jpg",
    testimonial: "Realizacion de mantenimiento preventivo y correctivo a las plantas portabilizadoras."
  },
  {
    id: 3,
    name: "CENTRAL | Perforadora Central S.A. de C.V",
    logo: "https://gestionintegralpce.com/data3/images/tuxpan2.png",
    testimonial: "Proporciona los servicios de instalacion de patines hidraulicos."
  },
  {
    id: 4,
    name: "INCOTAB",
    logo: "https://scontent.fmex10-6.fna.fbcdn.net/v/t39.30808-6/361264578_927830579363765_4537392000775795973_n.png?_nc_cat=107&ccb=1-7&_nc_sid=2a1932&_nc_ohc=KWmkqyFRjR8Q7kNvwELnp7K&_nc_oc=Adr8nS2lBK-MfRax8iLzJhvmsL5moWnMC0TFxGvQMF5_upYjU8twO6EfxLrH6JBzLvmAB0sd_UZ-jPgM4R1rMG2H&_nc_zt=23&_nc_ht=scontent.fmex10-6.fna&_nc_gid=0XG5gs8PWbj-5__eksnXpA&_nc_ss=7a389&oh=00_Af3Qo5Ei6Sg5f9R0p3tgvXyfw47S2sPgkm38vLtQRqLxJQ&oe=69D76AAD",
    testimonial: "Se basa en la renta de plantas portabilizadoras."
  },
  {
    id: 5,
    name: "Construcción y Mantenimientos Integrales S.A de C.V",
    logo: "https://scontent.fmex10-3.fna.fbcdn.net/v/t39.30808-6/469249589_122142432002366271_5892657300146957803_n.jpg?_nc_cat=104&ccb=1-7&_nc_sid=2a1932&_nc_ohc=2csmEWpUqZsQ7kNvwE1jc0v&_nc_oc=AdopOIYzyY8l6r3ZfbfYxQmmTJ9RRCmxppVQOf6tzRMqjTbC1C5eZ4pL23VGswwKWdYWAWGPhKbD75vQXi-WpcnS&_nc_zt=23&_nc_ht=scontent.fmex10-3.fna&_nc_gid=9yjNzLMrVreihvm4Y0_Q7Q&_nc_ss=7a389&oh=00_Af1q-Br1BInPcR-gd3n_8X51q0OIJs6ApZN7K--O-Vrs1g&oe=69D7464E",
    testimonial: "Brinda materiales diversos para instalacion decampamentos offshore."
  },
  {
    id: 6,
    name: "Blue Marine",
    logo: "https://cdn.prod.website-files.com/651f0812d3f5546437ab5129/6560e550dfe38e8545b7f226_Logo.gif",
    testimonial: "Brinda suministros de materiales consumibles para las operaciones de las plantas portabilizadoras."
  },
  {
    id: 7,
    name: "Grupo TMM",
    logo: "https://www.ics-shipping.org/wp-content/uploads/2020/09/logo-TMM-BL-1024x393.png",
    testimonial: "Brinda suministros y servicios de materiales diversos."
  },
  {
    id: 8,
    name: "HFoffshrore",
    logo: "https://media.licdn.com/dms/image/v2/D4D22AQEtZzkzzGn_FQ/feedshare-shrink_800/feedshare-shrink_800/0/1727896074823?e=2147483647&v=beta&t=Qnes9dOEeoXen9CPSZWGUyjHLmh6u7ZgPy-WlPfG3NU",
    testimonial: "Brinda los suministros y servicios en instalacion de plantas portabilizadoras."
  },
  {
    id: 9,
    name: "ENERGIA NAVIERA",
    logo: "https://cameintram.org/wp/wp-content/uploads/2021/06/EN.jpg",
    testimonial: "Cliente Potencial"
  }
];

export const Marcas = [
  {
  id: 1,
  name: "CAT PUMPS",
  logo: "https://findlogovector.com/wp-content/uploads/2018/10/cat-pumps-logo-vector.png",
  testimonial: "Herramientas confiables",

  productos: [
    {
      nombre: "Bombas de Embolo Triplex",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-001.jpg",
      descripcion: "Bombas de émbolo Triplex de desplazamiento positivo de alta presión para uso industrial"
    },
    {
      nombre: "Amortiguadores",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-002.jpg",
      descripcion: "Amortiguadores de pulsaciones de uso industrial para un rendimiento de salida suave"
    },
    {
      nombre: "Aceite para carter ISO-68",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-003.jpg",
      descripcion: "Aceite"
    },
    {
      nombre: "Kit de Válvulas",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-004.jpg",
      descripcion: "Valvulas"
    },
    {
      nombre: "Kits de Sellos",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-005.jpg",
      descripcion: "Pulidora resistente para trabajos pesados"
    },
  ]
},
{
  id: 2,
  name: "+GF+",
  logo: "https://techflow.com.mx/wp-content/uploads/2020/06/08-GF.png",
  testimonial: "Herramientas confiables",

  productos: [
    {
      nombre: "Sensores de Conductividad",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-007.jpg",
      descripcion: "sensor"
    }
  ]
},
{
  id: 3,
  name: "LG Chem | Water Solution",
  logo: "https://product.statnano.com/resource/amar_university_world/files/images/21/1/thumbnail_da0ee0348cf67d555d2a8aecc6f1b0aa.jpg",
  testimonial: "Herramientas confiables",

  productos: [
    {
      nombre: "Membranas",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-009.jpg",
      descripcion: "Membranas de ósmosis inversa"
    }
  ]
},
{
  id: 4,
  name: "Nitto | innovation for costumers",
  logo: "https://www.cornerstoneondemand.com/_next/image/?url=https%3A%2F%2Fcdn.sanity.io%2Fimages%2F43ea2a5t%2Fresources-new-3%2Fbd107f1250846ff219195e6fd4e968e1cb719cea-454x159.svg&w=1920&q=75",
  testimonial: "Herramientas confiables",

  productos: [
    {
      nombre: "Membrana",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-011.jpg",
      descripcion: "Membrana hydranautics"
    }
  ]
},
{
  id: 5,
  name: "Azcue pumps",
  logo: "https://rodavigo.net/datos/logos-marcas-png/azcue.png",
  testimonial: "Herramientas confiables",

  productos: [
    {
      nombre: "Bomba",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-013.jpg",
      descripcion: "Bomba Azcue"
    },
    {
      nombre: "Centrifugas",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-014.jpg",
      descripcion: "Centrifugas"
    }
  ]
},
{
  id: 6,
  name: "Cematic",
  logo: "https://www.plastico.com/logos/profile/limage-11446.jpg",
  testimonial: "Herramientas confiables",

  productos: [
    {
      nombre: "Válvula Solenoide",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-016.jpg",
      descripcion: "Válvula Solenoide Latón Alta Presión - Uso Industrial "
    },
    {
      nombre: "Válvula Solenoide",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-017.jpg",
      descripcion: " Válvula Solenoide Acero Inoxidable Directa NA Alto Flujo Alta Temperatura "
    }
  ]
},
{
  id: 7,
  name: "ALTAMIRA",
  logo: "https://hidroshop.mx/wp-content/uploads/logo-Altamira.jpg",
  testimonial: "Herramientas confiables",

  productos: [
    {
      nombre: "Motobomba",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-019.jpg",
      descripcion: "Motobomba sumergible para efluentes y lodos"
    },
    {
      nombre: "Motor sumergible",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-021.jpg",
      descripcion: "Motor sumergible"
    }
    
  ]
},
{
  id: 8,
  name: "AQUA PAK",
  logo: "https://encrypted-tbn0.gstatic.com/images?q=tbn:ANd9GcSXGAhHsRn5PaWscFojjptCE5GhOCYlvmKOvw&s",
  testimonial: "Herramientas confiables",

  productos: [
    {
      nombre: "Motobomba sumergible",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-023.jpg",
      descripcion: "Motobomba sumergible para efluentes y lodos de alto paso de sólidos"
    }
  ]
},
{
  id: 9,
  name: "GRUNDFOS",
  logo: "https://teisa.com.mx/wp-content/uploads/2022/06/grundfo-e1579555213763.webp",
  testimonial: "Herramientas confiables",

  productos: [
    {
      nombre: "Bomba sumergible",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-025.jpg",
      descripcion: " Bomba sumergible para pozo profundo"
    }
  ]
},
{
  id: 10,
  name: "PURIKOR",
  logo: "https://azulimx.com/wp-content/uploads/2021/08/Purikor_C.jpg",
  testimonial: "Herramientas confiables",

  productos: [
    {
      nombre: "Zeolita mineral",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-031.jpg",
      descripcion: "Resina"
    },
    {
      nombre: "Zeolita mineral",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-032.jpg",
      descripcion: "Zeolita"
    },
    {
      nombre: "Zeolita mineral",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-030.jpg",
      descripcion: "Carbón Activado"
    },
    {
      nombre: "Zeolita mineral",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-029.jpg",
      descripcion: "Grava"
    },
    {
      nombre: "Sistema de desinfección",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-033.jpg",
      descripcion: "Sistema de desinfección con luz UV"
    },
    {
      nombre: "Manga de cuarzo",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-034.jpg",
      descripcion: "Manga de cuarzo para lámpara UV modelo PLATINUM "
    },
    {
      nombre: "filtros",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-035.jpg",
      descripcion: "filtros de polipropileno y carbón"
    },
     {
      nombre: " Medidores de flujo",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-036.jpg",
      descripcion: "Medidores de flujo"
    },
    {
      nombre: " Sistemas de filtración ",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-037.jpg",
      descripcion: "Sistemas de filtración"
    },
    {
      nombre: "Membranas",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-038.jpg",
      descripcion: "Membranas"
    },
    {
      nombre: "Tanques de fibra",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-039.jpg",
      descripcion: "Tanques de fibra de vidrio"
    },
    {
      nombre: "Cartuchos y filtros",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-040.jpg",
      descripcion: "Cartuchos y filtros Hydronix"
    }
  ]
},
{
  id: 11,
  name: "FRANKLIN ELECTRIC",
  logo: "https://argalbombas.com.mx/wp-content/uploads/2024/06/logo-franklin.jpg",
  testimonial: "Herramientas confiables",

  productos: [
    {
      nombre: "Motor sumergible",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-027.jpg",
      descripcion: "Motor sumergible"
    }
  ]
},
{
  id: 12,
  name: "Danfoss",
  logo: "https://thefoodtech.com/wp-content/uploads/2021/10/Danfoss-scaled.jpg",
  testimonial: "Herramientas confiables",

  productos: [
    {
      nombre: "Bombas",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-042.jpg",
      descripcion: "Bombas de alta presión Danfoss"
    },
    {
      nombre: "Kit de reparación",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-043.jpg",
      descripcion: "Kit de reparación de bombas Danfoss"
    }
  ]
},
{
  id: 13,
  name: "Shneider Electric",
  logo: "https://sunbeamsafetyuae.com/wp-content/uploads/2025/09/se.png",
  testimonial: "Herramientas confiables",

  productos: [
    {
      nombre: "CONTACTORES",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-045.jpg",
      descripcion: "CONTACTORES SCHNEIDER"
    },
    {
      nombre: "RELEVADORES",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-046.jpg",
      descripcion: "RELEVADORES SCHNEIDER"
    }
  ]
},
{
  id: 14,
  name: "PENTAIR",
  logo: "https://hidroshop.mx/wp-content/uploads/Logo-Pentair.jpg",
  testimonial: "Herramientas confiables",

  productos: [
    {
      nombre: "Filtros y porta filtros",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-048.jpg",
      descripcion: "Filtros y porta filtros"
    },
    {
      nombre: "Porta membranas",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-049.jpg",
      descripcion: "Porta membranas"
    },
    {
      nombre: "Portafiltros Shelco",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-050.jpg",
      descripcion: "Portafiltros Shelco"
    }
  ]
},
{
  id: 15,
  name: "Blue-White",
  logo: "https://seastore.com.mx/wp-content/uploads/2020/12/blue-white1.jpg",
  testimonial: "Herramientas confiables",

  productos: [
    {
      nombre: "Medidores de flujo",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-052.jpg",
      descripcion: "Medidores de flujo"
    }
  ]
},
{
  id: 16,
  name: "Allen-Bradley",
  logo: "https://rodavigo.net/datos/logos-marcas-png/allen-bradley.png",
  testimonial: "Herramientas confiables",

  productos: [
    {
      nombre: " PLC",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-054.jpg",
      descripcion: "PLC"
    },
    {
      nombre: " Pantalla touch",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-055.jpg",
      descripcion: "Pantalla touch"
    },
    {
      nombre: " Modulo analógico",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-056.jpg",
      descripcion: "Modulo analógico"
    }
  ]
},
{
  id: 17,
  name: "DE WIT",
  logo: "https://dewitneumatica.mx/web/image/686/btn-inico-01.jpg",
  testimonial: "Herramientas confiables",

  productos: [
    {
      nombre: "Manómetros",
      imagen: "/imagenes/PRODUCTO Y MARCAS.pdf-image-058.jpg",
      descripcion: "Manómetros"
    }
  ]
}
];

export const locationInfo = {
  address: "Almendros 22, 23 de Julio, 24155 Cdad. del Carmen, Camp.",
  phone: "+52-938-129-2671",
  email: "serviciosssf@gmail.com o servicios@ssfiltraciones.mx",
  hours: "Lunes a Viernes: 9:00 AM - 4:00 PM",
  mapUrl: "https://www.google.com/maps/embed?pb=!1m17!1m12!1m3!1d1836.4805592940506!2d-91.78805252659244!3d18.637633880397537!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m2!1m1!2zMTjCsDM4JzE0LjciTiA5McKwNDcnMTMuMCJX!5e0!3m2!1ses!2smx!4v1775587604775!5m2!1ses!2smx"
};

export const socialMedia = [
  {
    name: "Facebook",
    icon: "facebook",
    url: "https://facebook.com/ssf-filtracion"
  },
  {
    name: "Twitter",
    icon: "twitter",
    url: "https://twitter.com/ssf_filtracion"
  },
  {
    name: "LinkedIn",
    icon: "linkedin",
    url: "https://linkedin.com/company/ssf-filtracion"
  }
];
